import Phaser from "phaser";

interface MiniMapConfig {
    scene: Phaser.Scene;
    x: number;
    y: number;
    width: number;
    height: number;
    worldWidth: number;
    worldHeight: number;
}

export class MiniMap {
    private readonly scene: Phaser.Scene;
    private readonly x: number;
    private readonly y: number;
    private readonly width: number;
    private readonly height: number;
    private readonly worldWidth: number;
    private readonly worldHeight: number;
    private readonly graphics: Phaser.GameObjects.Graphics;

    constructor(config: MiniMapConfig) {
        this.scene = config.scene;
        this.x = config.x;
        this.y = config.y;
        this.width = config.width;
        this.height = config.height;
        this.worldWidth = config.worldWidth;
        this.worldHeight = config.worldHeight;
        this.graphics = this.scene.add.graphics().setScrollFactor(0).setDepth(110);
    }

    update(boat: Phaser.Physics.Arcade.Sprite, fishGroup: Phaser.GameObjects.Group, powerUpGroup: Phaser.GameObjects.Group): void {
        this.graphics.clear();

        this.graphics.fillStyle(0x112f45, 0.8);
        this.graphics.fillRoundedRect(this.x, this.y, this.width, this.height, 12);
        this.graphics.lineStyle(2, 0xa8d9ff, 0.6);
        this.graphics.strokeRoundedRect(this.x, this.y, this.width, this.height, 12);

        this.graphics.fillStyle(0x8fd3ff, 0.95);
        this.drawDot(this.worldToMapX(boat.x), this.worldToMapY(boat.y), 4);

        this.graphics.fillStyle(0xa7f09d, 0.9);
        fishGroup.getChildren().forEach((child) => {
            const fish = child as Phaser.GameObjects.Sprite;
            if (!fish.active || !fish.visible) {
                return;
            }
            this.drawDot(this.worldToMapX(fish.x), this.worldToMapY(fish.y), 2);
        });

        this.graphics.fillStyle(0xffd88a, 0.95);
        powerUpGroup.getChildren().forEach((child) => {
            const power = child as Phaser.GameObjects.Sprite;
            if (!power.active || !power.visible) {
                return;
            }
            this.drawDot(this.worldToMapX(power.x), this.worldToMapY(power.y), 2.5);
        });
    }

    private worldToMapX(worldX: number): number {
        return this.x + (worldX / this.worldWidth) * this.width;
    }

    private worldToMapY(worldY: number): number {
        return this.y + (worldY / this.worldHeight) * this.height;
    }

    private drawDot(x: number, y: number, radius: number): void {
        this.graphics.fillCircle(x, y, radius);
    }
}
